import React, { useState, useEffect } from "react";
import axios from "axios";
import routes from "../../../app/routes";
import DataTable from "react-data-table-component";

export default function Cycles({ memberId }) {
  const [collection, setCollection] = useState([]);
  const [loaded, setLoaded] = useState(true);

  const updateCollection = () => {
    setLoaded(true);
    axios.get(routes.api.students.cycles_status(memberId)).then((resp) => {
      setLoaded(false);
      setCollection(resp.data);
    });
  };

  useEffect(() => {
    updateCollection();
  }, []);

  const columns = [
    {
      name: "#",
      selector: "position",
      sortable: true,
      width: "80px",
    },
    {
      name: "Cycle",
      selector: "title",
      sortable: true,
    },
    {
      name: "Interval",
      selector: "start",
      sortable: true,
      cell: (row) => `${row.start} - ${row.end}`,
    },
    {
      name: "Status",
      selector: "status",
      cell: (row) => `${row.status == null ? "Not Enrolled" : row.status}`,
    },
  ];

  return (
    <>
      <div className="ibox mt20">
        <div className="ibox-content">
          <div>
            <h2 className="data mt0">Enrollment Cycles</h2>
          </div>
          {loaded && <p className="text-center mt20">Processing...</p>}

          {!loaded && (
            <>
              {collection.count == 0 && (
                <p className="text-center mt20">
                  Mmeber does not have enrollment cycles
                </p>
              )}
              {!collection.count > 0 && (
                <div className="mt10">
                  <DataTable
                    title=""
                    columns={columns}
                    data={collection}
                    noDataComponent="No matching records found"
                    persistTableHead={true}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}
